import { MouseEvent, Suspense, lazy } from 'react';
import FontAwesomeIcon from '../../../../../../../common/font-awesome-icon/font-awesome-icon';
import LinkButton from '../../../../../../../common/link-button/link-button';
import WorldSwitch from '../../../../../../../common/world-switch/world-switch';
import { helpCenter } from '../../../../../../../constants/contact-data';
import { LINK_THEMES } from '../../../../../../../constants/link-themes';
import translation, { world } from '../../../../../../../languages';
import { MENU_STATE_TYPES } from '../../user-menu.constants';

const LoggedInState = lazy(
    () => import(/* webpackChunkName: "logged-in-state" */ '../logged-in-state/logged-in-state')
);
const Login = lazy(() => import(/* webpackChunkName: "login" */ '../../../../../../../common/login/login'));
const SignUp = lazy(() => import(/* webpackChunkName: "sign-up" */ '../../../../../../../common/sign-up/sign-up'));

type MenuContentPropsType = TranslationProps & {
    menuState: MENU_STATE_TYPES;
    setMenuState: (menuState: MENU_STATE_TYPES) => void;
};

const MenuContent = ({ menuState, setMenuState, t }: MenuContentPropsType) => {
    const toggleMenuState = (e: MouseEvent, menuState: MENU_STATE_TYPES) => {
        e.preventDefault();
        e.stopPropagation();
        setMenuState(menuState);
    };

    if (menuState === MENU_STATE_TYPES.LOGGED_IN) {
        return (
            <Suspense fallback={<div />}>
                <LoggedInState />
            </Suspense>
        );
    }

    if (menuState === MENU_STATE_TYPES.LOGIN) {
        return (
            <div className='logged-in d-flex flex-wrap'>
                <div className='left-part'>
                    <Suspense fallback={<div />}>
                        <Login showLabels />
                    </Suspense>
                    <div className='help text-center mt-4'>
                        <a href={helpCenter[world]}>{t('header.userMenu.help')}</a>
                    </div>
                </div>
                <div className='right-part d-flex flex-column'>
                    <div>
                        <h5 className='title bold'>{t('header.userMenu.loginForm.notMemberYet')}</h5>
                        <div className='subTitle'>{t('header.userMenu.loginForm.becomePart')}</div>
                        <ul className='list'>
                            <li>{t('header.userMenu.loginForm.list.option1')}</li>
                            <li>{t('header.userMenu.loginForm.list.option2')}</li>
                            <li>{t('header.userMenu.loginForm.list.option3')}</li>
                        </ul>
                        <div
                            className='arrow-btn cursor-pointer'
                            onClick={(e) => toggleMenuState(e, MENU_STATE_TYPES.REGISTR)}
                        >
                            <span className='arrow-btn-text tsc-body-highlighted'>
                                {t('header.userMenu.loginForm.registerForFree')}
                            </span>
                            <FontAwesomeIcon height={24} name='arrow-right' theme='black' />
                        </div>
                    </div>
                    <div className='d-flex align-items-end justify-content-end word-switcher-wrapper'>
                        <WorldSwitch />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className='sign-up-menu'>
            <Suspense fallback={<div />}>
                <SignUp showLabels />
            </Suspense>
            <div className='help text-center mt-4'>
                <a href={helpCenter[world]}>{t('header.userMenu.help')}</a>
            </div>
            <div className='d-flex align-items-center justify-content-between mt-24'>
                <div className='lmp-secondary'>
                    <div className='tsc-body-highlighted-lg'>{t('header.userMenu.alreadyRegisteredNew')}</div>
                    <div>
                        <LinkButton
                            className='mt-12'
                            theme={LINK_THEMES.GREEN}
                            href='#'
                            onClick={(e) => toggleMenuState(e, MENU_STATE_TYPES.LOGIN)}
                            text={t('header.userMenu.loginForm.newsletterButton')}
                        />
                    </div>
                </div>
                <WorldSwitch />
            </div>
        </div>
    );
};

const translate = translation('header');

export default translate(MenuContent);
